import { ProgressBar } from '@/components/ui';

import { formatLimit, usageRatio } from './money';

/**
 * What the company is using against what its plan allows.
 *
 * A meter is only drawn when there is a limit to draw it against. An
 * unlimited allowance rendered as a bar at 3% would suggest a ceiling that
 * does not exist, so it is a sentence instead.
 */
export function UsageMeters({ usage, entitlements, atLimitNote }) {
  const rows = [
    {
      key: 'internships',
      label: 'Live internships',
      used: usage.active_internships,
      limit: entitlements.max_active_internships,
      noun: 'live internships',
    },
    {
      key: 'team',
      label: 'Team members',
      used: usage.team_members,
      limit: entitlements.max_team_members,
      noun: 'team members',
    },
  ];

  return (
    <ul className="space-y-4">
      {rows.map((row) => {
        const ratio = usageRatio(row.used, row.limit);
        return (
          <li key={row.key}>
            <div className="mb-1 flex items-baseline justify-between gap-3 text-sm">
              <span className="text-ink font-medium">{row.label}</span>
              <span className="text-ink-muted text-xs">
                {row.limit === null
                  ? `${row.used} of ${formatLimit(null, row.noun).toLowerCase()}`
                  : `${row.used} of ${row.limit}`}
              </span>
            </div>
            {ratio === null ? (
              <p className="text-ink-muted text-xs">No limit on this plan.</p>
            ) : (
              <ProgressBar value={ratio} />
            )}
            {ratio !== null && row.used >= row.limit && (
              <p className="mt-1 text-xs text-warning-700">
                {atLimitNote ??
                  'You are at your limit. Close one you are no longer hiring for, or move to a bigger plan.'}
              </p>
            )}
          </li>
        );
      })}
    </ul>
  );
}
